import { MRT_Row } from '@talentmesh/table';
import { TypographySmall } from '@talentmesh/ui/components/typography';
import { TeamMember } from '@/Models/TeamMember';

interface NameAndEmailProps {
    row: MRT_Row<TeamMember>;
}

function NameAndEmail({ row }: NameAndEmailProps) {
    const { firstName, lastName, email, id } = row.original;
    return (
        <div className="flex flex-col gap-2" data-id={id}>
            {firstName && lastName && (
                <TypographySmall>
                    {firstName} {lastName}
                </TypographySmall>
            )}
            <TypographySmall>{email}</TypographySmall>
        </div>
    );
}

export default NameAndEmail;
